// Re-export pure functions from core
export {
  getShareExtension,
  buildShareUrl,
  extractPasscodeFromUrl,
  isExpiringSoon,
  getExpiryProgress,
  getExpiryColorScheme,
} from '@core/utils/share-url'

// Re-export parseShareIdParam from core/filename (also used by share-url consumers)
export { parseShareIdParam } from '@core/utils/filename'

// Browser-dependent functions (use window.location.origin)

import { buildShareUrl } from '@core/utils/share-url'

/**
 * Build an absolute share URL including origin
 */
export function buildFullShareUrl(shareId: string, extension: string, passcode?: string | null, mode?: string): string {
  return `${window.location.origin}${buildShareUrl(shareId, extension, passcode, mode)}`
}

/**
 * Build an absolute embed URL for a share
 */
export function buildEmbedUrl(shareId: string, extension: string, passcode?: string | null): string {
  const base = `${window.location.origin}/embed/${shareId}${extension}`
  return passcode ? `${base}#${passcode}` : base
}

/**
 * Build an iframe embed code snippet
 */
export function buildEmbedCode(shareId: string, extension: string, passcode?: string | null): string {
  const url = buildEmbedUrl(shareId, extension, passcode)
  return `<iframe src="${url}" width="100%" height="500" frameborder="0"></iframe>`
}

/**
 * Build a raw content URL for a share
 */
export function buildRawUrl(shareId: string, extension: string, passcode?: string | null, isPublic?: boolean): string {
  const base = `${window.location.origin}/raw/${shareId}${extension}`
  if (isPublic) return base
  if (passcode) return `${base}#${passcode}`
  return `${base}#YOUR_PASSCODE`
}
